import { Route } from 'react-router-dom'
import Signup from './pages/Signup'

const PatientRegistrationRoutes = [
  <Route
    exact
    path="/cadastro/:page/:idClinic?"
    key="/cadastro"
    component={Signup}
  />,
]

export default PatientRegistrationRoutes
